<div class="upload-file-container">
  <div class="d-flex align-items-center">
    <svg
      width="44"
      height="36"
      viewBox="0 0 44 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.2754 0.17801C23.9007 0.0705294 18.3571 3.14834 16.8364 10.0931C10.6473 7.98058 5.05904 12.1471 5.63953 18.7998C2.40125 20.1088 0.125 23.2724 0.125 26.9907C0.125 31.8869 4.06668 35.8286 8.96289 35.8286H19.699C19.696 32.8531 19.6898 26.8826 19.6898 25.7517L17.1721 26.6641C15.3456 27.4513 13.9965 25.1512 15.5607 23.7191L20.3245 19.0896C21.4126 18.0016 22.7122 18.1263 23.6754 19.0896L28.4392 23.7191C30.0034 25.1512 28.6544 27.4513 26.8279 26.6641L24.3102 25.7517V35.8286H35.0371C39.9333 35.8286 43.875 31.8869 43.875 26.9907C43.875 23.387 41.736 20.3065 38.6565 18.9279C44.6236 7.29508 37.1307 0.33486 29.2754 0.17801Z"
        fill="#7EAAAE" />
      <path
        d="M29.2757 0.177C28.9763 0.171094 28.6477 0.181374 28.348 0.194661C21.4833 11.0133 32.0924 18.9264 38.6568 18.9264C44.6239 7.29347 37.131 0.333309 29.2757 0.176459V0.177Z"
        fill="#47858B" />
    </svg>

    <div
      class="content-wrapper d-flex flex-column mx-3 w-100"
      (click)="triggerInput()">
      <input
        #attachment
        [id]="inputFileId"
        type="file"
        (change)="onFileChanged($event)" />
      <span class="font-14 dark font-medium-bold"
        >{{ "Click-To-Browse" | translate }}</span
      >
      <span class="light font-12">{{ "File-Types" | translate }}</span>
    </div>
  </div>
  @if (fileInfo) {
  <div class="uploaded-file-container d-flex">
    <!-- @if (fileInfo && !filesArr) for multi-->
    <div class="upload-file-wrapper d-flex">
      <svg
        width="34"
        height="38"
        viewBox="0 0 34 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 0C6.19375 0 5.125 1.06875 5.125 2.375V35.625C5.125 36.9313 6.19375 38 7.5 38H31.25C32.5562 38 33.625 36.9313 33.625 35.625V9.5L24.125 0H7.5Z"
          fill="#E2E5E7" />
        <path
          d="M26.5 9.5H33.625L24.125 0V7.125C24.125 8.43125 25.1938 9.5 26.5 9.5Z"
          fill="#B0B7BD" />
        <path d="M33.625 16.625L26.5 9.5H33.625V16.625Z" fill="#CAD1D8" />
        <path
          d="M28.875 30.875C28.875 31.5281 28.3406 32.0625 27.6875 32.0625H1.5625C0.909375 32.0625 0.375 31.5281 0.375 30.875V19C0.375 18.3469 0.909375 17.8125 1.5625 17.8125H27.6875C28.3406 17.8125 28.875 18.3469 28.875 19V30.875Z"
          fill="#F15642" />
        <path
          d="M5.55176 22.4997C5.55176 22.1862 5.79876 21.8442 6.19657 21.8442H8.38988C9.62488 21.8442 10.7364 22.6707 10.7364 24.2549C10.7364 25.7559 9.62488 26.5919 8.38988 26.5919H6.80457V27.8459C6.80457 28.2639 6.53857 28.5002 6.19657 28.5002C5.88307 28.5002 5.55176 28.2639 5.55176 27.8459V22.4997ZM6.80457 23.0401V25.4055H8.38988C9.02638 25.4055 9.52988 24.8439 9.52988 24.2549C9.52988 23.591 9.02638 23.0401 8.38988 23.0401H6.80457Z"
          fill="white" />
        <path
          d="M12.5959 28.5001C12.2824 28.5001 11.9404 28.3291 11.9404 27.9123V22.5187C11.9404 22.1779 12.2824 21.9297 12.5959 21.9297H14.7702C19.1094 21.9297 19.0144 28.5001 14.8557 28.5001H12.5959ZM13.1944 23.0887V27.3423H14.7702C17.3341 27.3423 17.4481 23.0887 14.7702 23.0887H13.1944Z"
          fill="white" />
        <path
          d="M20.5534 23.1649V24.6742H22.9747C23.3167 24.6742 23.6587 25.0162 23.6587 25.3475C23.6587 25.661 23.3167 25.9175 22.9747 25.9175H20.5534V27.9113C20.5534 28.2438 20.3171 28.4991 19.9846 28.4991C19.5666 28.4991 19.3113 28.2438 19.3113 27.9113V22.5177C19.3113 22.1769 19.5678 21.9287 19.9846 21.9287H23.3179C23.7359 21.9287 23.9829 22.1769 23.9829 22.5177C23.9829 22.8217 23.7359 23.1637 23.3179 23.1637H20.5534V23.1649Z"
          fill="white" />
        <path
          d="M27.6875 32.0625H5.125V33.25H27.6875C28.3406 33.25 28.875 32.7156 28.875 32.0625V30.875C28.875 31.5281 28.3406 32.0625 27.6875 32.0625Z"
          fill="#CAD1D8" />
      </svg>

      @if (!uploadedFile) {
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex flex-column mx-3">
          <span class="font-14 dark font-medium-bold"
            >{{ fileInfo?.name }}</span
          >
          <span class="light font-12">{{ fileInfo?.size }} KB</span>
        </div>

        <button
          type="button"
          class="icon-wrapper btn-reset"
          [attr.aria-label]="'Aria.Delete' | translate"
          (click)="onRemoveFile()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      }

      <!-- todo : change the way of uploading and downloading file in all system -->
      @if (uploadedFile) {
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex flex-column mx-3">
          <a
            class="font-14 dark font-medium-bold cursor-pointer"
            (click)="downLoadFile()">
            {{ uploadedFile }}
          </a>
        </div>

        <button
          type="button"
          class="icon-wrapper btn-reset"
          [attr.aria-label]="'Aria.Delete' | translate"
          (click)="onRemoveFile()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      }
    </div>
  </div>
  }
</div>
